import type { MenuItemListTypes } from '@Shelly/shelly-design-system';
import type { ChartConfig } from 'src/types/Chart';

export type ChartTimeType = { from: Date; to: Date };

export type ChartMoreActionType = Omit<Partial<MenuItemListTypes>, 'title'> & {
	title: {
		value: string;
		translation: string;
	};
	id: string;
};

export type ChartMoreActionsGroupType = {
	groupTitle: {
		translation?: string;
		value?: string;
	};
	isGroupTitle?: boolean;
	items: ChartMoreActionType[];
};

export const chartMoreActionsGroupedItems: ChartMoreActionsGroupType[] = [
	{
		groupTitle: {
			value: 'General',
			translation: 'chart_more_options_general_label',
		},
		isGroupTitle: true,
		items: [
			{
				id: 'fullScreen',
				title: {
					value: 'Full screen',
					translation: 'chart_more_options_full_screen_label',
				},
				icon: 'fas fa-up-right-and-down-left-from-center',
				isSelectable: false,
			},
			{
				id: 'exportFile',
				title: {
					value: 'Export .csv',
					translation: 'chart_more_options_export_label',
				},
				icon: 'fas fa-file-arrow-down',
				isSelectable: false,
			},
			{
				id: 'netMetering',
				title: {
					value: 'Net Metering',
					translation: 'net_metering_tab',
				},
				icon: 'fas fa-solar-panel',
				isSelectable: false,
			},
		],
	},
	{
		groupTitle: {
			value: 'Chart type',
			translation: 'chart_more_options_chart_type_label',
		},
		isGroupTitle: true,
		items: [
			{
				id: 'bar',
				title: {
					value: 'Bar chart',
					translation: 'chart_more_options_chart_type_bar_label',
				},
				icon: 'fas fa-chart-column',
				isSelectable: true,
			},
			{
				id: 'areaspline',
				title: {
					value: 'Smooth area chart',
					translation: 'chart_more_options_chart_type_smooth_label',
				},
				icon: 'fa-solid fa-chart-area ',
				isSelectable: true,
			},
			{
				id: 'area',
				title: {
					value: 'Sharp area chart',
					translation: 'chart_more_options_chart_type_sharp_label',
				},
				icon: 'fa-sharp fas fa-chart-area',
				isSelectable: true,
			},
			{
				id: 'line',
				title: {
					value: 'Line chart',
					translation: 'chart_more_options_chart_type_line_label',
				},
				icon: 'fas fa-chart-line',
				isSelectable: true,
			},
		],
	},
];

export const getDefaultMatrix = (len: number) => {
	return Array.from(Array(len), () => new Array());
};

export const setSelectedItemID = (chartConfig: ChartConfig) => {
	let foundAction: ChartMoreActionType;
	chartMoreActionsGroupedItems.forEach((gItem) => {
		foundAction = gItem.items.find((item) => item.id === chartConfig.type);
	});
	return foundAction.id;
};
